// Group GROUP 10. Noun Phrases and Modification
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group10Data = {
  "id": "group_10",
  "title": {
    "tc": "名詞片語與修飾",
    "sc": "名词短语与修饰",
    "en": "Noun Phrases and Modification"
  },
  "subtitle": {
    "tc": "Noun Phrases and Modification",
    "sc": "Noun Phrases and Modification",
    "en": "Noun Phrases and Modification"
  },
  "icon": "📝",
  "difficulty": "intermediate",
  "color": "from-teal-500 to-teal-600",
  "topics": [
    {
      "id": "pre_modification",
      "title": {
        "tc": "名詞前置修飾",
        "sc": "名词前置修饰",
        "en": "Pre-modification"
      },
      "description": {
        "tc": "學習名詞前置修飾的用法",
        "sc": "学习名词前置修饰的用法",
        "en": "Learn the usage of pre-modification"
      },
      "icon": "📋",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "pre_mod_1",
          "sentence": "a well-known Italian fashion brand",
          "analysis": "a (Det) well-known (Adj) Italian (Adj) fashion (N-mod) brand (N-head)",
          "translation": {
            "tc": "一個知名的義大利時尚品牌",
            "sc": "一个知名的意大利时尚品牌",
            "en": "a well-known Italian fashion brand"
          }
        },
        {
          "id": "pre_mod_2",
          "sentence": "a highly effective marketing strategy",
          "analysis": "a (Det) highly (Adv) effective (Adj) marketing (N-mod) strategy (N)",
          "translation": {
            "tc": "一個高度有效的行銷策略",
            "sc": "一个高度有效的营销策略",
            "en": "a highly effective marketing strategy"
          }
        },
        {
          "id": "pre_mod_3",
          "sentence": "an ambitious long-term research project",
          "analysis": "an (Det) ambitious (Adj) long-term (Adj) research (N-mod) project (N)",
          "translation": {
            "tc": "一個雄心勃勃的長期研究項目",
            "sc": "一个雄心勃勃的长期研究项目",
            "en": "an ambitious long-term research project"
          }
        },
        {
          "id": "pre_mod_4",
          "sentence": "a small portable Bluetooth speaker",
          "analysis": "a (Det) small (Adj) portable (Adj) Bluetooth (N-mod) speaker (N)",
          "translation": {
            "tc": "一個小型便攜藍牙音箱",
            "sc": "一个小型便携蓝牙音箱",
            "en": "a small portable Bluetooth speaker"
          }
        },
        {
          "id": "pre_mod_5",
          "sentence": "a clear and consistent policy",
          "analysis": "a (Det) clear (Adj) and (conj) consistent (Adj) policy (N)",
          "translation": {
            "tc": "一個清楚一致的政策",
            "sc": "一个清楚一致的政策",
            "en": "a clear and consistent policy"
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：形容詞順序常為意見-大小-年齡-形狀-顏色-國籍-材料-用途-名詞。",
        "sc": "要点：形容词顺序常为意见-大小-年龄-形状-颜色-国籍-材料-用途-名词。",
        "en": "Key points: adjective order is often opinion-size-age-shape-color-nationality-material-purpose-noun."
      }
    },
    {
      "id": "post_modifying_pps",
      "title": {
        "tc": "名詞後置：介詞片語",
        "sc": "名词后置：介词短语",
        "en": "Post-modifying PPs"
      },
      "description": {
        "tc": "學習名詞後置介詞片語的用法",
        "sc": "学习名词后置介词短语的用法",
        "en": "Learn the usage of post-modifying prepositional phrases"
      },
      "icon": "📍",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "post_pp_1",
          "sentence": "The man in the blue jacket is my uncle.",
          "analysis": "The man (S) in the blue jacket (Post-mod) is (V) my uncle (C).",
          "translation": {
            "tc": "穿藍色夾克的男人是我叔叔。",
            "sc": "穿蓝色夹克的男人是我叔叔。",
            "en": "The man in the blue jacket is my uncle."
          }
        },
        {
          "id": "post_pp_2",
          "sentence": "The book on the table is mine.",
          "analysis": "The book (S) on the table (Post-mod) is (V) mine (C).",
          "translation": {
            "tc": "桌上的書是我的。",
            "sc": "桌上的书是我的。",
            "en": "The book on the table is mine."
          }
        },
        {
          "id": "post_pp_3",
          "sentence": "The road to the airport is closed.",
          "analysis": "The road (S) to the airport (Post-mod) is (V) closed (C).",
          "translation": {
            "tc": "通往機場的路被封閉了。",
            "sc": "通往机场的路被封闭了。",
            "en": "The road to the airport is closed."
          }
        },
        {
          "id": "post_pp_4",
          "sentence": "The house by the river was flooded.",
          "analysis": "The house (S) by the river (Post-mod) was flooded (V-pass).",
          "translation": {
            "tc": "河邊的房子被淹了。",
            "sc": "河边的房子被淹了。",
            "en": "The house by the river was flooded."
          }
        },
        {
          "id": "post_pp_5",
          "sentence": "The cafe across the street opens early.",
          "analysis": "The cafe (S) across the street (Post-mod) opens (V) early (M).",
          "translation": {
            "tc": "街對面的咖啡館開得很早。",
            "sc": "街对面的咖啡馆开得很早。",
            "en": "The cafe across the street opens early."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：介詞片語作定語；清楚限定名詞。",
        "sc": "要点：介词短语作定语；清楚限定名词。",
        "en": "Key points: prepositional phrases as modifiers; clearly define nouns."
      }
    }
  ]
};
